import { render, staticRenderFns } from "./PopupAddEmailTemplate.vue?vue&type=template&id=3f62ef70&scoped=true&"
import script from "./PopupAddEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./PopupAddEmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62ef70",
  null
  
)

export default component.exports